// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'reactstrap';

type Props = {
  header: string,
  print?: boolean,
}

@observer
export default class OverviewHeader extends React.Component<Props, any> {
  
  handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 0);
  };
  
  render() {
    const { print, header } = this.props;
    return (
      <Row>
        <Col>
          { print ? (
            <div className="float-right d-print-none">
              <Button color="secondary" onClick={this.handlePrint}>{'Drucken'}</Button>
            </div>
          ) : null}
          <h1>{header}</h1>
        </Col>
      </Row>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/Components/Layout/OverviewHeader/index.js